import { Box, styled } from '@mui/material'

// DataGrid descendant styling lives in the omui MuiDataGrid theme override
// (apps/frontend/shared/omui/src/theme2/components/MuiDataGrid.ts).
// This wrapper only sizes the layout.
export const DataGridContainer = styled(Box)({
  flexGrow: 1,
  maxHeight: '100%',
  height: '100%',
})
